// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const leatherRoll = defineModel({
  id: "leather-roll",
  batchId: "future",
  name: "Leather roll",
  tags: ["scenery","leather","roll","low-poly","age-of-mcp","future"],
  summary: "Rolled tanned leather — harness, bags, bellows, boots and armour.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.38,
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.075, 0.08, 0.42, 11), color: "#7a4a2c", position: [-0.13, 0.21, 0.04] },
      { geometry: new THREE.TorusGeometry(0.082, 0.01, 5, 11), color: "#3f2a18", position: [-0.13, 0.126, 0.04], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.TorusGeometry(0.082, 0.01, 5, 11), color: "#3f2a18", position: [-0.13, 0.294, 0.04], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.075, 0.08, 0.36, 11), color: "#6b4026", position: [0.05, 0.18, -0.08] },
      { geometry: new THREE.TorusGeometry(0.082, 0.01, 5, 11), color: "#3f2a18", position: [0.05, 0.108, -0.08], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.TorusGeometry(0.082, 0.01, 5, 11), color: "#3f2a18", position: [0.05, 0.252, -0.08], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.07, 0.07, 0.32, 11), color: "#7a4a2c", position: [0.16, 0.07, 0.16], rotation: [1.570796, 0, 0.2] },
      { geometry: new THREE.TorusGeometry(0.075, 0.01, 5, 11), color: "#3f2a18", position: [0.16, 0.07, 0.16], rotation: [0, 0, 0.2] },
    ],
  animations: [],
});
